import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterDropdown } from '../molecules/FilterDropdown';
import { OPS_GROUP_OPTIONS } from 'constants/shipper';
const OPS_GROUPS = OPS_GROUP_OPTIONS;
/**
 * Shared operations group multi-select filter.
 * Uses OPS_GROUP_OPTIONS constant.
 */
export function OpsGroupFilter({ value, onChange }) {
    const { t } = useTranslation();
    const allValues = OPS_GROUPS.map((o) => o.slug);
    const options = OPS_GROUPS.map((type) => ({
        value: type.slug,
        label: t(type.localizationSlug),
    }));
    return (React.createElement(FilterDropdown, { title: t('OPS_GROUP'), options: options, selected: value, onCheckedChange: (item, checked) => {
            onChange(checked ? [...value, item] : value.filter((v) => v !== item));
        }, onSelectAll: () => onChange([...allValues]), onClear: () => onChange([]) }));
}
